import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination"
import { useTranslation } from "react-i18next";

export default function FeatureCarousel() {
  const { t } = useTranslation();

  const features = [
    {
      title: <><span className="text-[#9B29FF]">{t('featureCarousel.feature1TitleHighlight')}</span> {t('featureCarousel.feature1TitleRest')}</>,
      description: t('featureCarousel.feature1Description'),
    },
    {
      title: <>{t('featureCarousel.feature2TitleHighlight')} <span className="text-[#9B29FF]">{t('featureCarousel.feature2TitleRest')}</span></>,
      description: t('featureCarousel.feature2Description'),
    },
    {
      title: t('featureCarousel.feature3Title'),
      description: t('featureCarousel.feature3Description'),
    },
  ];

  return (
    <div className="sm:hidden ml-responsive mt-16">
      {/* Mobile / Small screens */}
      <div className="md-hidden-swiper">
        <Swiper
          modules={[Pagination]}
          spaceBetween={10}
          slidesPerView={1}
          pagination={{ clickable: true, el: '.feature-swiper-pagination' }}
          className="w-full"
        >
          {features.map((feature, index) => (
            <SwiperSlide key={index}>
              <div className="flex items-center justify-center relative w-full px-6">
                {/* Left Divider */}
                <img
                  src={require("../media/images/Line2.png")}
                  alt="Divider"
                  className="absolute left-4"
                />

                {/* Text */}
                <div className="flex-1 mx-12 text-center">
                  <h2 className="text-black text-2xl mb-2">{feature.title}</h2>
                  <p className="text-base">{feature.description}</p>
                </div>

                {/* Right Divider */}
                <img
                  src={require("../media/images/Line2.png")}
                  alt="Divider"
                  className="absolute right-4"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Pagination below carousel */}
        <div className="feature-swiper-pagination mt-4 flex justify-center"></div>
      </div>
    </div>
  );
}
